<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home' }">{{ $t('nav.home') }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ $t('nav.music') }}
        </li>
      </ol>
    </nav>
    <b-row>
      <b-col sm="2">
        <div>
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-button variant="outline-info" @click="newArtist()">
                <font-awesome-icon :icon="['fas', 'user-plus']" />
              </b-button>
            </b-input-group-prepend>
            <b-form-input v-model="filtArtist" >
            </b-form-input>
            <b-input-group-append>
              <b-button @click="filterArtist()" >
                <font-awesome-icon :icon="['fas', 'search']" />
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="danger" @click="CancelFilter">
                <font-awesome-icon :icon="['fas', 'times']" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <ArtistCard v-for="a in artistsFiltered" :key="a.art_id" :item="a"
          :selected="currentArtist && a.art_id === currentArtist.art_id" @click="SelectArtist(a)">
        </ArtistCard>
        <b-modal id="newArtist" title="Création d'un Artist" centered @cancel="resetNewArtist()" @ok="createNewArtist()" @hide="resetNewArtist()"
        >
        <b-form-group
          label="Nom"
          label-for="name-input"
          invalid-feedback="Nom est obligatoire"
        >
          <b-form-input
            id="name-input"
            v-model="tempNewArtist.art_name"
            :state="tempNewArtist.NameIsValidNotExist(artists)"
            required
          ></b-form-input>
        </b-form-group>
        </b-modal>
      </b-col>
      <b-col>
        <div v-if="currentArtist" class="mb-3">
          <b-input-group prepend="Ajouter un album" >
              <b-form-file
                
                v-model="newAlbumFolder"
                placeholder="Choisir un répertoire ou déposer ici..."
                drop-placeholder="Déposer ici..."
                :directory="true" 
                multiple
                browse-text="Choisir"
              ></b-form-file>          
            <b-input-group-append>
              <b-button 
                @click="extractTracks()" 
                :disabled="newAlbumFolder === null"
                :variant="newAlbumFolder !== null ? 'success': ''"
                >Extraire les pistes</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button ref="btnUndo" :variant="newAlbumFolder !== null? 'danger': 'secondary'" @click="newAlbumFolder = null">
                  <font-awesome-icon :icon="['fas', 'times']" />
                </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>          
        <b-table v-if="currentArtist" 
          :items="currentArtist.albums" 
          :fields="alb_fields" small responsive="sm" head-variant="light"
          ref="tableAlbum"
          >
          <template #cell(alb_id)="data">
            {{ data.value }}
          </template>
          <template #cell(ass_id)="row">
            <div  class="text-left" >
              <b-form-group  cols="1" class=" p-0">
                 <b-input-group size="sm">
                  <b-input-group-prepend>
                      <img :src="row.item.image" alt="Photo Album" width="30" height="30" />
                    </b-input-group-prepend>
                  <b-form-file 
                    v-if="IsThisAlbum(row.item)"
                    size="sm" 
                    accept="image/*" 
                    v-model="row.item.file" 
                    placeholder="Fichier"
                    browse-text="..."
                    @input="changeFile(row.item)"
                    ></b-form-file>
                  <b-input-group-append v-if="IsThisAlbum(row.item)">
                    <b-button variant="danger" @click="CancelEditImage(row.item)">
                      <font-awesome-icon :icon="['fas', 'times']" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>                 
            </div>
          </template>
          <template #cell(alb_name)="row">
            <div v-if="IsThisAlbum(row.item)">
              <b-form-input 
                v-model="row.item.alb_name" 
                required
                :state="row.item.NameIsValid(currentArtist.albums)"
                placeholder="Nom de l'album"
                class="formEdit">
                {{ row.item.alb_name }}
              </b-form-input>
            </div>
            <div v-else>
              {{ row.item.alb_name }}
            </div>
          </template>
          <template #cell(alb_description)="row">
            <div v-if="IsThisAlbum(row.item)">
              <b-form-input 
                v-model="row.item.alb_description" 
                placeholder="Description sommaire de l'album"
                class="formEdit"
              >
                {{ row.item.alb_description }}
              </b-form-input>
            </div>
            <div v-else>
            {{ row.item.alb_description }}
            </div>  
          </template>
          <template #cell(alb_year)="row">
            <div v-if="IsThisAlbum(row.item)">
              <b-form-input
                type="number"
                v-model="row.item.alb_year" 
                placeholder="Année de sortie de l'album"
                class="formEdit"
                :state="row.item.YearIsValid()"
                >
                {{ row.item.alb_year }}
              </b-form-input>
            </div>
            <div v-else>
            {{ row.item.alb_year }}
            </div>  
          </template>     
          <template #cell(genres)="row">
            <div v-if="IsThisAlbum(row.item)">
              <b-form-select
                placehoder="Choisir un genre"
                v-model="row.item.genres"
                :options="genres"
                class="mb-3 formEdit"
                value-field="gmus_id"
                text-field="gmus_label"
                disabled-field="notEnabled"
                multiple
              >
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Choisir un genre --</b-form-select-option>
                </template>                  
            </b-form-select>
            </div>
            <div v-else>
              {{ GenresName(row.item) }}
            </div>
          </template>     
          <template #cell(details)="row">
            <b-button :disabled="!(editAlbum === null || IsThisAlbum(row.item))" size="sm"
              @click="IsThisAlbum(row.item) ? submitAlbum(row.item) : onEdit(row.item)"
              :variant="colorSaveAlbum(row.item)">
              <font-awesome-icon v-if="IsThisAlbum(row.item)" :icon="['fas', 'save']" />
              <font-awesome-icon v-if="!IsThisAlbum(row.item)" :icon="['fas', 'edit']" />
            </b-button>
            <b-button v-if="IsThisAlbum(row.item)" size="sm"
              @click="UndoAlbum()"
              class="editbtn"
              >
              <font-awesome-icon :icon="['fas', 'undo']" />
            </b-button>
            <b-button size="sm" @click="ShowListTracks(row)" class="editbtn">
              <font-awesome-icon :icon="['fas', row.detailsShowing ?'eye-slash': 'eye']" /> Pistes
            </b-button>

          </template>
          <template #row-details="row">
            <b-card border-variant="success">
              <b-table 
                :items="row.item.tracks" 
                :fields="trk_fields" 
                small responsive="sm" head-variant="light"
                ref="tableTrack"
                >
                <template #cell(trk_id)="data">
                  {{ data.value }}
                </template>
                <template #cell(trk_number)="row">
                  <div v-if="IsThisTrack(row.item)">
                    <b-form-input 
                      v-model="row.item.trk_number" 
                      class="formEdit"
                      placeholder="N° de la piste"
                      required
                      >
                      {{ row.item.trk_number }}
                    </b-form-input>
                  </div>
                  <div v-else>
                  {{ row.item.trk_number }}
                  </div>  
                </template>
                <template #cell(trk_name)="row">
                  <div v-if="IsThisTrack(row.item)">
                  <b-form-input 
                      v-model="row.item.trk_name" 
                      class="formEdit"
                      required
                      placeholder="Nom de la piste"
                      :state="row.item.NameIsValid()"
                      >
                      {{ row.item.trk_name }}
                    </b-form-input>
                  </div>
                  <div v-else>
                    {{ row.item.trk_name }}
                  </div>
                </template>
                <template #cell(trk_description)="row">
                  <div v-if="IsThisTrack(row.item)">
                  <b-form-input 
                      v-model="row.item.trk_description" 
                      class="formEdit"
                      placeholder="Description sommaire de la piste"
                      >
                      {{ row.item.trk_description }}
                    </b-form-input>
                  </div>
                  <div v-else>
                    {{ row.item.trk_description }}
                  </div>
                </template>
                <template #cell(trk_year)="row">
                  <div v-if="IsThisTrack(row.item)">
                  <b-form-input 
                      type="number"
                      v-model="row.item.trk_year" 
                      class="formEdit"
                      placeholder="Année de sortie de la piste"
                      :state="row.item.YearIsValid()"
                      >
                      {{ row.item.trk_year }}
                    </b-form-input>
                  </div>
                  <div v-else>
                  {{ row.item.trk_year }}
                  </div>
                </template>
                <template #cell(trk_duration)="row">
                  <div v-if="IsThisTrack(row.item)">
                    <b-input-group>
                      <b-form-input
                        class="formEdit"
                        size="sm"
                        v-model="row.item.trk_duration"
                        type="text"
                        placeholder="hh:mm:ss"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-timepicker
                          v-bind="timeLabel"
                          button-variant="secondary"
                          class="formEdit"
                          size="sm" 
                          v-model="row.item.trk_duration"
                          button-only
                          right
                          show-seconds
                          locale="fr"
                          :state="row.item.DurationIsValid()"
                          reset-button
                          reset_value="00:00:00"
                        ></b-form-timepicker>
                      </b-input-group-append>
                    </b-input-group>                    
                  </div>
                  <div v-else>
                  {{ row.item.trk_duration }}
                  </div>
                </template>                
                <template #cell(trk_gmus_id)="row">
                  <div v-if="IsThisTrack(row.item)">
                    <b-form-select
                      v-model="row.item.trk_gmus_id"
                      :options="genres"
                      class="mb-3 formEdit"
                      value-field="gmus_id"
                      text-field="gmus_label"
                      disabled-field="notEnabled"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Choisir un genre --</b-form-select-option>
                      </template>                  
                    </b-form-select>
                  </div>
                  <div v-else>
                  {{ GenreName(row.item.trk_gmus_id) }}
                  </div>  
                </template>                
                <template #cell(details)="row">
                  <div class="details">
                    <b-button :disabled="!(editTrack === null || IsThisTrack(row.item))" size="sm"
                      @click="IsThisTrack(row.item) ? submitTrack(row.item) : onEditTrk(row.item)"
                      :variant="colorSaveTrack(row.item)" >
                      <font-awesome-icon v-if="IsThisTrack(row.item)" :icon="['fas', 'save']" />
                      <font-awesome-icon v-if="!IsThisTrack(row.item)" :icon="['fas', 'edit']" />
                    </b-button>
                    <b-button v-if="IsThisTrack(row.item)" size="sm"
                      @click="UndoTrack()"
                      class="editbtn"
                      >
                      <font-awesome-icon :icon="['fas', 'undo']" />
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-card>
          </template>
        </b-table>
            <!-- Info modal -->
        <b-modal :id="infoModal.id" :title="infoModal.title" centered @cancel="resetInfoModal" @hide="resetInfoModal" @ok="okInfoModal">
          <pre>{{ infoModal.content }}</pre>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Artists, Albums, Tracks, Asset, Genres,SaveArtist, SaveTrack, SaveAlbum, CreateArtist, SaveAsset, SaveMp3, SaveTracksOfAlbum } from "../services/music";
import ArtistCard from "../components/ArtistCard.vue";
import LoadAlbumFolder from "../misc/LoadFolderAlbum.js";

export default {
  components: {
    ArtistCard
  },
  name: 'Musique',
  data() {
    return {
      tempNewArtist: CreateArtist(''),
      infoModal: {
          context: '',
          contextRow: 0,
          id: 'info-modal',
          title: '',
          content: ''
      },      
      timeLabel: {
            labelHours: 'Heures',
            labelMinutes: 'Minutes',
            labelSeconds: 'Secondes',
            labelIncrement: 'Plus',
            labelDecrement: 'Moins',
            labelSelected: 'Selection',
            labelNoTimeSelected: 'Pas de temps',
            labelCloseButton: 'Fermer',
            labelResetButton: 'Réinitialiser'
          },
      newAlbumFolder: null,
      filtArtist: null,
      currentArtist: null,
      editAlbum: null,
      editTrack: null,
      artists: null,
      artistsFiltered: null,
      genres: null,
      trk_fields: [
        {
          trk_id: {
            label: 'Id',
            sortable: true,
            tdClass: "text-center",
          },
        },
        {
          trk_number: {
            label: 'Piste',
            sortable: true,
            tdClass: "text-right",
          },
        },
        {
          trk_name: {
            label: 'Nom',
            sortable: true,
            tdClass: "text-left",
          },
        },
        {
          trk_duration: {
            label: 'Durée',
            sortable: false,
            tdClass: "text-left",
          },
        },
        {
          trk_description: {
            label: 'Description',
            sortable: false,
            tdClass: "text-left",
          }
        },
        {
          trk_year: {
            label: 'Année',
            sortable: true,
            tdClass: "text-right",
          },
        },
        {
          trk_gmus_id: {
            label: 'Genre',
            sortable: true,
            tdClass: "text-center",
          },
        },
        {
          details: {
            label: "Détails",
            sortable: false,
            tdClass: "details",
          },
        },
      ],
      alb_fields: [
        {
          alb_id: {
            label: 'Id',
            sortable: true,
            tdClass: "text-center",
          },
        },
        { 
          ass_id: {
            label: 'Image',
            sortable: false,
            tdClass: "text-center",
          }
        },
        {
          alb_name: {
            label: 'Nom',
            sortable: true,
            tdClass: "text-left",
          },
        },
        {
          alb_description: {
            label: 'Description',
            sortable: false,
            tdClass: "text-left",
          }
        },
        {
          alb_year: {
            label: 'Année',
            sortable: true,
            tdClass: "text-right",
          }
        },
        {
          genres: {
            label: 'Genre',
            sortable: false,
            tdClass: "text-center",
          }
        },
        {
          details: {
            label: "Détails",
            sortable: false,
            tdClass: "text-right",
          },
        },
      ],
    }
  },
  computed: {
    
  },
  async created() {
    this.artists = await Artists();
    this.artistsFiltered = this.artists.slice(0);
    this.genres = await Genres();
  },
  methods: {
    createBase64Image(item) {
      const reader = new FileReader();
      reader.onload = (event) => {
        item.old.image = item.file;
        item.image = event.target.result;
      }
      reader.readAsDataURL(item.file);
    },
    changeFile(item){
      if (item.file) {
        this.createBase64Image(item)
      }
    },  
    CancelEditImage(item) {
      if (item.file) {
        item.image =item.old.image;
        item.old.image = null;
        item.file = null;
      }
    },  
    newArtist(){
      this.$root.$emit('bv::show::modal', 'newArtist');
    },
    resetNewArtist(){
      this.tempNewArtist = CreateArtist('');
      this.$root.$emit('bv::show::hide', 'newArtist');
    },
    async createNewArtist(){
      if (this.tempNewArtist.NameIsValidNotExist(this.artists)){
        const result = await SaveArtist(this.tempNewArtist);
        if (result) {
          this.artists = await Artists();
          this.filterArtist();
          this.tempNewArtist = CreateArtist('');
        }
        this.$root.$emit('bv::show::hide', 'newArtist');
      }
    },   
    cleanInfoModal(){
      this.infoModal.title = '';
      this.infoModal.content = '';
      this.infoModal.context = '';
      this.infoModal.contextRow = 0;
    },
    async resetInfoModal(){
      if ( this.infoModal.context === 'ALBUM')  await Albums(this.currentArtist.art_id);
      this.cleanInfoModal();
      this.newAlbumFolder = null;
      this.$refs.btnUndo.focus();
    },
    async okInfoModal(){
      const item = this.currentArtist.albums[this.infoModal.contextRow];
      const result = await SaveAlbum(this.currentArtist.art_id, item);
      if (result && result.length > 0){

        item.alb_id = result[0].alb_id;
        if (item.ass_id === null && item.file) {
          const assId = await SaveAsset(item.alb_id, 'ALBUM', item.file, item.file.name);
          if (assId > 0) item.ass_id = assId;
        }
        await SaveTracksOfAlbum(item);
        // Selection dans l'affichage
        this.$refs.tableAlbum.selectRow(this.currentArtist.albums.length -1);
        this.$set(item, '_showDetails', true);
      }
      this.resetInfoModal();
      this.newAlbumFolder = null;
      this.$refs.btnUndo.focus();
    },
    codePointsToString(cps) {
      let rs = [];
      let batch = 32767; // Supported 'all' browsers
      for (let i = 0; i < cps.length; ){
        let e = i + batch;
        // Build batch section, defer to Array.join.
        rs.push(String.fromCodePoint.apply(null, cps.slice(i, e)));
        i = e;
      }
      return rs.join('');
    },
    getGenreId(value){
      const result = this.genres.filter((el) => el.gmus_label.toLowerCase().includes(value.toLowerCase()))
      if (result && result.length > 0) return result[0].gmus_id;
      return null;
    },
    async extractTracks(){
      // lecture du répertoire
      const album = await LoadAlbumFolder(this.newAlbumFolder);
      if (album) {
        let editAlbum = this.currentArtist.albums.find((a) => a.alb_name.toLowerCase() === album.name.toLowerCase());
        if (!editAlbum){
          // Création de l'album
            editAlbum = this.currentArtist.createAlbum( { 
            art_id : this.currentArtist.art_id,
            alb_id: null, 
            alb_name: album.name, 
            genres: album.genres.map(g => this.getGenreId(g)).filter(g => g !== null), 
            alb_year: album.year || 1970, 
            tracks: []
          });
          // valeur par défaut pour le genre
          if (editAlbum.genres.length < 1) editAlbum.genres.push(this.getGenreId('pop'));
        } 
        else {
          // ensure tracks is loaded
          editAlbum.tracks = await Tracks(editAlbum.alb_id);
        }
        if (editAlbum.image.data) editAlbum.file = album.image;
        // ajout des pistes
        let countTrack = 0;
        album.tracks.forEach(t => {
          countTrack += 1;
          const existTrack = editAlbum.tracks?.find((tr) => tr.trk_name.toLowerCase() === t.title.toLowerCase());
          if (!existTrack) {
            editAlbum.createTrack({
              trk_id: null,
              trk_ass_id: null,
              trk_name: t.title,
              trk_number: t.track || countTrack,
              trk_duration: t.duration,
              trk_year: t.year,
              trk_gmus_id: (t.genres && t.genres.length > 0) ? this.getGenreId(t.genres[0]): null,
              file: t.file
            })
          } else {
            existTrack.file = t.file;
          }
        });
        // Image à afficher
        if (album.image.data) editAlbum.image = `data:/image;base64,${btoa(this.codePointsToString(album.image.data))}`;
        // Modal de validation de l'ajout en base
        this.infoModal.context = 'ALBUM';
        this.infoModal.contextRow = this.currentArtist.albums.findIndex((a) => a.alb_name.toLowerCase() === editAlbum.alb_name.toLowerCase() );
        this.infoModal.title = `Ajout de l'Album: ${editAlbum.alb_name} de ${ album.artists}`;
        this.infoModal.content = JSON.stringify(editAlbum.tracks.map(t => {
          return `${t.trk_number} - ${t.trk_name} : ${t.trk_duration}`;
        }), null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id)
      } else {

        this.newAlbumFolder = null;
        this.showToast("danger", "Le repertoire ne contient pas de fichier mp3", "Lecture ALbum",5000, true, false, 'b-toaster-top-center');
      }
    },
    filterArtist(){
      if (this.filtArtist !== null){
        this.artistsFiltered = this.artists.filter((a) => a.art_name.toLowerCase().includes(this.filtArtist.toLowerCase())).slice(0);
        if( !this.artistsFiltered.includes(this.currentArtist)) this.currentArtist = null;
      }
      else {
        this.artistsFiltered = this.artists.slice(0);
      }
    },
    CancelFilter(){
      this.filtArtist = null;
      this.filterArtist()
    },
    IsThisTrack(item){
      return (this.editTrack !== null && this.editTrack?.trk_id === item.trk_id)
    },
    IsThisAlbum(item){
      return (this.editAlbum !== null && this.editAlbum?.alb_id === item.alb_id)
    },
    GenresName(album){
      const values = album.genres.map((genre) => {
        const el = this.genres.find(g => g.gmus_id === genre);
        if (el)
            return  el.gmus_label ;
        return null;
      });

      return values.filter(x => x !== null).join(',');
    },
    GenreName(genre){
      const el = this.genres.find(g => g.gmus_id === genre);
      if (el)
        return  el.gmus_label ;
      return '';
    },
    async onEdit(alb) {
      if (this.editAlbum === null) this.editAlbum = alb;

      if (this.editAlbum.isDefaultImage) {
        const image = await Asset(alb.ass_id, 'alb');
        if (image) {
          alb.image = image;
          alb.isDefaultImage = false;
        }
      }
    },
    onEditTrk(trk) {
      if (this.editTrack === null) this.editTrack = trk;
    },
    UndoAlbum(){
      if (this.editAlbum) this.editAlbum.undo();
      this.editAlbum = null;
    },
    UndoTrack(){
      if (this.editTrack) this.editTrack.undo();
      this.editTrack = null;
    },
    async ShowListTracks(row) {
      row.toggleDetails();
      if (!row.item.trackAdded)
        row.item.tracks = await Tracks(row.item.alb_id);
    },
    colorSaveAlbum(item){
      return this.colorSave(this.IsThisAlbum(item), item);
    },
    colorSaveTrack(item){
      return this.colorSave(this.IsThisTrack(item), item);
    },
    colorSave(inItem, item){
      if (inItem)
          if (item.modified() && item.isValid()) return 'success';
          else return 'danger';
        return 'secondary';      
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return;
      if (item._showDetails || this.editAlbum.art_id === item.art_id) return 'table-success';
    },
    async submitAlbum(item) {
      if (item.isValid()){
        if (item.modified() ){
          const result = await SaveAlbum(this.currentArtist.art_id, item);
          if (result) {
              if (result.status === "INS"){
              item.alb_id = result.alb_id;
              item.saveForUndo();
            }
            if (item.file) {
              const assId = await SaveAsset(item.alb_id, 'ALBUM', item.file, item.file.name)
            }

            this.editAlbum = null;
          }
        }
      }
      else return;
    },
    async submitTrack(item, alb_id){
      if (item.isValid()) {
        if (item.modified()){
          console.log('item', item)
          const result = await SaveTrack(item.alb_id, item);
          if (result) {
            if (result.status === "INS"){
              item.trk_id = result.trk_id;
              item.saveForUndo();
            }
            this.editTrack = null;
          }
        }
      }
    },
    async SelectArtist(a) {
      this.currentArtist = a;
      this.currentArtist.albums = await Albums(a.art_id);
      if (this.currentArtist.isDefaultImage && a.ass_id !== null) {
        const image = await Asset(a.ass_id, 'art');
        if (image) {
          a.image = image;
          a.isDefaultImage = false;
        }
      }
      a.selected = true;
      this.currentArtist.albums.forEach(async (alb) => {
        if (alb.isDefaultImage && alb.ass_id !== null) {
          const image = await Asset(alb.ass_id, 'alb');
          if (image) {
            alb.image = image;
            alb.isDefaultImage = false;
          }
        }
      });
      this.newAlbumFolder = null;
    }
  },
};
</script>

<style scoped>
.formEdit {
  font-size: 0.79em;
  font-weight: bold;
}

</style>

<style>
.details {
  display: flex;
}
.editbtn {
  margin-left: 0.2rem;
}

</style>
